import React from 'react';
export function Events() {
  return <main className="pt-24 min-h-screen flex flex-col items-center justify-center px-6" data-id="element-128">
      <div className="max-w-3xl w-full text-center fade-section" data-id="element-129">
        <h1 className="font-serif text-[50px] md:text-[62px] text-white mb-6" data-id="element-130">
          Private Events
        </h1>
        <div className="w-16 h-px bg-gold mx-auto mb-8" data-id="element-131" />
        <p className="font-sans text-lg text-white/70 mb-12 leading-relaxed" data-id="element-132">
          Host your next unforgettable gathering at Tempoo. From intimate
          dinners to full venue buyouts, our space offers the perfect backdrop
          for celebrating life's special moments with authentic West African
          flair.
        </p>

        <div className="bg-charcoal p-8 md:p-12 border border-white/5" data-id="element-133">
          <h2 className="font-sans text-base tracking-widest text-gold uppercase mb-6" data-id="element-134">
            Inquire About Your Event
          </h2>
          <p className="font-sans text-lg text-white/60 mb-8" data-id="element-135">
            Please contact our events team to discuss availability, custom
            menus, and bottle service packages.
          </p>
          <a href="tel:2405359729" className="inline-block border border-gold text-gold px-8 py-4 font-sans uppercase tracking-widest text-base font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-136">
            Call (240) 535-9729
          </a>
        </div>
      </div>
    </main>;
}